import { Contact, Link } from "./models";

export const isNumeric = (num: any): boolean => {
  const dt = typeof num;
  if (
    num !== null &&
    num !== undefined &&
    (dt === "number" || dt === "string")
  ) {
    const floatVal = dt === "number" ? num : parseFloat(num);
    return !isNaN(floatVal) && isFinite(floatVal);
  } else {
    return false;
  }
};

export const notEmptyString = (str, minLength = 0) => {
  if (typeof str === "string") {
    return str.trim().length > minLength;
  }
  return false;
};

export const emptyString = (str, maxLength = 0) =>
  !notEmptyString(str, maxLength);

export const validDateString = (date, withTime) => {
  let valid = typeof date === "string";
  if (valid) {
    let pattern = `^\\s*[12]\\d\\d\\d-[0-1]?\\d-[0-3]\\d?`;
    if (withTime === true) {
      pattern += `(T|\\s+)[0-2]?\\d:[0-5]?\\d:[0-5]?\\d(\\.\\d+)?Z?`;
    }
    pattern += "\\s*$";
    const rgx = new RegExp(pattern, "i");
    valid = rgx.test(date);
  }
  return valid;
};

export const validDateTimeString = (date) => {
  return validDateString(date, true);
};

export const validPassword = (pass, minLength = 6, mode = "") => {
  let valid = false;
  if (typeof pass === "string") {
    pass = pass.trim();
    if (!minLength) {
      minLength = 8;
    }
    if (pass.length >= minLength) {
      // very loose check any characters except spaces and at least one alphanumeric char
      valid = /^.*?\w+.*?$/i.test(pass);
      switch (mode) {
        case "strict":
          if (valid) {
            valid =
              /[a-z]/.test(pass) && /[A-Z]/.test(pass) && /[0-9]/.test(pass);
          }
          break;
      }
    }
  }
  return valid;
};

export const validEmail = (identifier) => {
  let valid = false;
  if (typeof identifier === "string") {
    valid = identifier.length > 5 && /^[^@]+@\w/.test(identifier);
  }
  return valid;
};

export const validUrl = (identifier) => {
  let valid = false;
  if (typeof identifier === "string") {
    const rgx = /^((https?):\/\/)?\w[^ ]+\.\w/i;
    valid = identifier.trim().length > 5 && rgx.test(identifier.trim());
  }
  return valid;
};

export const filterLink = (lk) => {
  let valid = false;
  if (lk instanceof Object) {
    if (Object.keys(lk).includes("url")) {
      valid = validUrl(lk.url);
    }
  }
  return valid;
};

export const filterLinkTitle = (lk = null) => {
  let valid = false;
  if (lk instanceof Object) {
    if (Object.keys(lk).includes("title")) {
      valid = notEmptyString(lk.title);
    }
  }
  return valid;
};

export const validCourseCode = (str = ""): boolean => {
  return typeof str === "string" ? /\w\w-\w\w?\w?-\w/.test(str) : false;
};

export const filterStatement = (st) => {
  let valid = false;
  if (st instanceof Object) {
    const keys = Object.keys(st);
    if (keys.includes("type") && keys.includes("text")) {
      valid =
        notEmptyString(st.type) &&
        (notEmptyString(st.text, 3) || notEmptyString(st.image, 3));
    }
  }
  return valid;
};

/* export const validPhoneNumber = (code) => {
  if (typeof code === "string") {
    return /^(\s*\+*\s*)?[0-9 )(-]+\d\d\s*\d+[0-9 )(-]+$/.test(code);
  }
}; */

export const isUntitled = (title) => {
  return notEmptyString(title) && title.indexOf("[untitled]") >= 0;
};

export const validMediaTitle = (title) => {
  return title.trim().length > 2 && !isUntitled(title);
};

export const validateMediaItem = (item) => {
  if (item instanceof Object) {
    if (item.filename.length > 5 && item.title) {
      return validMediaTitle(item.title);
    }
    return false;
  }
};

export const workMediaValidate = (work) => {
  if (work instanceof Object) {
    if (work.mediaItems instanceof Array) {
      return work.mediaItems.length > 0;
    }
  }
  return false;
};

export const workMediaDescValidate = (work) => {
  let valid = false;
  if (work instanceof Object) {
    valid = workMediaValidate(work);
    if (!valid) {
      if (work.description) {
        valid = notEmptyString(work.description, 10);
      }
    }
  }
  return valid;
};

export const countMediaItems = (submission) => {
  if (submission instanceof Object) {
    if (submission.works instanceof Array) {
      return submission.works
        .map((w) => {
          let num = 0;
          if (w instanceof Object) {
            if (w.mediaItems instanceof Array) {
              num = w.mediaItems.length;
            }
          }
          return num;
        })
        .reduce((a, b) => a + b, 0);
    }
  }
  return 0;
};

export const validLinkField = (link: Link) => {
  return (
    link.url.trim().length > 5 &&
    /^https?:\/\/\w+/.test(link.url.trim()) &&
    link.title.trim().length > 1
  );
};

export const notEmptyLinkField = (link: Link) => {
  return (
    notEmptyString(link.title) ||
    notEmptyString(link.url, 5) ||
    notEmptyString(link.description)
  );
};

export const validContact = (contact: Contact) => {
  return contact.identifier.trim().length > 4;
};
